import { Injector } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { BaseComponent } from './base';

export abstract class DialogBaseComponent<TModel> extends BaseComponent {

    // service instance
    private dialogBaseRef: DynamicDialogRef;
    private dialogBaseConfig: DynamicDialogConfig;

    constructor(dialogFormInjector: Injector) {
        super();
        // prepare instance
        this.dialogBaseRef = dialogFormInjector.get(DynamicDialogRef);
        this.dialogBaseConfig = dialogFormInjector.get(DynamicDialogConfig);
    }

    // get dialog data
    get dialogData(): TModel {
        const data = this.dialogBaseConfig.data;
        return data ? data as TModel : null;
    }

    // close dialog
    close(result: any = null) {
        this.dialogBaseRef.close(result);
    }
}